import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import 'rxjs/add/operator/toPromise';
import { AuthenticationService } from '../authentication/authentication.service';
import { LoggingService } from '../logging/logging.service';

import { LazyLoadEvent } from "../../models/DataTables/lazyLoadEvent";
import { AutoCompleteEvent } from "../../models/Utility/autoCompleteEvent";
import { Question } from '../../models/outModels/Question';
import { QuestionDisplay } from '../../models/outModels/Question';

@Injectable()
export class QuestionService {
	route = "/api/questions/";
	constructor(
		private http: HttpClient,
		private auth: AuthenticationService,
		private logging: LoggingService) { }

	search(event: LazyLoadEvent): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}${this.route}search`, JSON.stringify(event), { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	searchiInvalid(event: LazyLoadEvent): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}${this.route}search/invalid`, JSON.stringify(event), { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	get(id: number): Promise<Question> {
		return this.http.get(`${this.auth.apiUrl}${this.route}get/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response as Question)
			.catch(error => this.logging.handleError(error));
	}

	getQuestionsForDirectory(id: number): Promise<QuestionDisplay[]> {
		return this.http.get(`${this.auth.apiUrl}${this.route}list/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response as Question[])
			.catch(error => this.logging.handleError(error));
	}

	getQuestionCountForDirectory(id: number): Promise<number> {
		return this.http.get(`${this.auth.apiUrl}${this.route}count/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response as number)
			.catch(error => this.logging.handleError(error));
	}

	getQuestionToDisplay(id: number): Promise<QuestionDisplay> {
		return this.http.get(`${this.auth.apiUrl}${this.route}get/display/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response as QuestionDisplay)
			.catch(error => this.logging.handleError(error));
	}

	getAnswered(id: number): Promise<QuestionDisplay[]> {
		return this.http.get(`${this.auth.apiUrl}${this.route}list/answered/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response as QuestionDisplay[])
			.catch(error => this.logging.handleError(error));
	}

	getRandomQuestion(id: number): Promise<any> {
		return this.http.get(`${this.auth.apiUrl}${this.route}get/random/${id}`, { headers: this.auth.header })
			.toPromise()
			.then( response => response as Question )
			.catch(error => error);
	}

	answerQuestion(answer: any): Promise<Question> {
		console.log(answer);		
		return this.http.post(`${this.auth.apiUrl}${this.route}answer`, JSON.stringify(answer), { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	resetQuestion(id: number): Promise<any> {
		return this.http.get(`${this.auth.apiUrl}${this.route}reset/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	getDropDown(event: AutoCompleteEvent): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}${this.route}dropdown`, JSON.stringify(event), { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}
	
}



// WEBPACK FOOTER //
// ./src/app/services/assessment/question.service.ts